import Context from "shared/util/Context";
import OnPageAds from "shared/modules/onpageads";
import Timezone from "shared/util/Timezone";
import {
	isDesktop,
	isMobile,
	isIOS,
	isAndroid,
	isDev,
	isDevjail,
} from "shared/util/EnvironmentHelpers";
import isStandaloneMode from "shared/util/isStandaloneMode";
import getBrowserInfo from "shared/util/getBrowserInfo";
import {
	ROUTES,
	ROUTE_TITLES,
} from "./consts";
import SentryHelper, { DSN } from "shared/util/SentryHelper";

export function getBodyClassList({
	adFree,
	hasPhotos,
	hasBoostTokens,
	isLoggedIn,
	isSPA,
	isIncognito,
} = {}) {
	const bodyClassList = [];

	if (isDesktop) {
		const {
			system,
			device,
			browser,
			webkitBrowserType,
		} = getBrowserInfo();

		if (system) {
			bodyClassList.push(system);
		}

		if (device) {
			bodyClassList.push(device);
		}

		if (browser) {
			bodyClassList.push(browser);
		}

		if (webkitBrowserType) {
			bodyClassList.push(webkitBrowserType);
		}

		if (adFree) {
			bodyClassList.push("comfree");
		}

		// Add a class if spotlight eligible.
		if (isLoggedIn && !isIncognito && (hasPhotos || hasBoostTokens)) {
			bodyClassList.push("spotlight");
		}
	} else if (isMobile) {
		if (isIOS || isAndroid) {
			bodyClassList.push("touch");
		}

		if (isIOS) {
			bodyClassList.push("iphone");
		} else if (isAndroid) {
			bodyClassList.push("android");
		}

		if (adFree) {
			bodyClassList.push("no_ads");
		}
	}

	if (isLoggedIn) {
		bodyClassList.push("logged_in");
	} else {
		bodyClassList.push("logged_out");
	}

	if (isSPA && isStandaloneMode()) {
		bodyClassList.push("spa--standalone");
	}

	return bodyClassList;
}

export function getPageName({
	pathname,
} = {}) {
	const [, pageName] = pathname.split("/");

	return `page--${pageName || "home"}`;
}

export function getPageTitle({
	pathname,
} = {}) {
	// Basically, look at all the possible paths for each route, and
	// find the one that matches. Then map it to a predefined title.
	const matchedRoute = Object.keys(ROUTES).find((routeKey) => {
		const allPossiblePaths = ROUTES[routeKey] || [];

		return allPossiblePaths.some((possiblePath) => pathname.match(possiblePath));
	});
	const pageTitle = ROUTE_TITLES[matchedRoute] || "—";

	return pageTitle;
}

export function initializeGlobals(globals) {
	const {
		context,
		sookies: {
			timezone,
		} = {},
		adInfo,
		user,
	} = globals || {};

	// Initialize global libraries.
	Context.init(context);
	Timezone.initialize(timezone);

	// Load ads if necessary.
	if (!Context.get("adFree")) {
		OnPageAds.loadAds(adInfo);
	}

	if (user.staffbarInfo) {
		window.StaffbarParams = {
			...user.staffbarInfo,
		};
	}

	// Initialize Sentry.
	if (!isDev || !isDevjail(window)) {
		SentryHelper.initSentry({
			dsn: isDesktop ? DSN.DesktopSPA : DSN.MobileSPA,
			environment: Context.get("env"),
			release: Context.get("activeRevision"),
			userid: Context.get("userid"),
		});
	}

	return globals;
}

export function shouldShowMobileLeaderboardAd() {
	return !!Context.get("userid") && !Context.get("adFree");
}

const BOOST_BANNER_TIMEOUT = 10 * 60 * 1000;

let _isBoostBannerBlocked = null;
export function shouldShowBoostHeader(isBoosting) {
	// User isn't logged in.
	if (!Context.get("userid")) {
		return false;
	}

	// They're boosting, show it.
	if (isBoosting) {
		return true;
	}

	// We showed it recently, chill.
	if (_isBoostBannerBlocked === true) {
		return false;
	}

	// First time running getting this far.
	// Hide it for non-alisters in favor of an ad.
	if (_isBoostBannerBlocked === null && !Context.get("adFree")) {
		_isBoostBannerBlocked = false;
		return false;
	}

	// Show it, but block it for a while.
	_isBoostBannerBlocked = true;
	setTimeout(() => {
		_isBoostBannerBlocked = false;
	}, BOOST_BANNER_TIMEOUT);

	return true;
}



// WEBPACK FOOTER //
// ./src/routers/shared/util/helpers.js